import axios from 'axios'
import Vue from 'vue'

export async function fetchHistorico(context){
    try{
        let url = "api/gethistorico"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let response = await Vue.axios({
            method: 'GET',
            url: url
        })

        context.commit('setHistorico', response.data)

    }catch(error){
        context.commit('ingenieriaError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }

}
export async function fetchOrdenes(context){
    try{
        let url = "api/getingenieria"//la direccion de la api
       
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
    
        let response = await Vue.axios({
            method: 'GET',
            url: url
        })
             
        context.commit('setOrdenes',response.data.data)
      
        }catch(error){
            context.commit('ingenieriaError', error)
        }
        finally{
            context.commit('setLoading',false,{root:true})
        }
}
/**
 * Metodo que cierra la orden 
 * @param {} context 
 * @param {*} payload 
 */
export async function cerrarOrden(context, payload){
    try{
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let url = "api/ingenieriacerrar"//direccion de la api
        let status = 'Cerrada'
        let values = new FormData()
        values.append('id',payload.id)
        values.append('comentario',payload.comentario)      
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setIsOk', true);//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchOrdenes')
    }catch(error){
        context.commit('ingenieriaError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function guardarOrdenar(context, payload){
    try{
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let url = "api/ingenieriaguardarorden"//direccion de la api
        let values = new FormData()
        values.append('id',payload.id)
        values.append('orden',payload.orden)      
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setIsOk', true);//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchOrdenes')
    }catch(error){
        context.commit('ingenieriaError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}
